module.exports = __webpack_public_path__ + "img/store.1cfed214.svg";